import { render, staticRenderFns } from "./ProjectMembersDescTile.vue?vue&type=template&id=c4dda8c0&scoped=true&lang=pug&"
import script from "./ProjectMembersDescTile.vue?vue&type=script&lang=js&"
export * from "./ProjectMembersDescTile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMembersDescTile.vue?vue&type=style&index=0&id=c4dda8c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dda8c0",
  null
  
)

export default component.exports